/* ===========================================================================
   #194 — APAGA EL ESQUELETO CUANDO LA IMAGEN YA PINTA.

   Todo el dibujo vive en `mi-esqueleto.css`; aquí sólo se marca cada imagen con
   `is-cargada`. Tres decisiones que conviene no deshacer:

   1. EL OYENTE VA EN CAPTURA SOBRE `document`, no uno por imagen. El evento
      `load` de una imagen NO burbujea, así que un oyente delegado normal no lo
      vería nunca; en fase de captura sí baja hasta ella. Con 203 imágenes en la
      home, esto es un oyente en lugar de doscientos.

   2. SE BARREN LAS QUE YA ESTABAN. Una imagen que salió de caché puede haber
      terminado ANTES de que este guion corra: su `load` ya pasó y no volverá.
      Por eso el primer barrido mira `complete && naturalWidth > 0`, que es la
      única forma fiable de saberlo.

   3. SE VIGILAN LAS QUE LLEGAN DESPUÉS. El riel sustituye su panel con las
      recomendaciones y el buscador pinta resultados: esas imágenes nacen ya
      empezada la página. Un `MutationObserver` las marca igual, y así no hay
      una sola foto que se quede brillando para siempre.
   =========================================================================== */
(function () {
  'use strict';

  function marcar(img) {
    if (!img || img.tagName !== 'IMG') return;
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-cargada');
    }
  }

  function barrer(raiz) {
    var imgs = (raiz || document).querySelectorAll('img:not(.is-cargada)');
    for (var i = 0; i < imgs.length; i++) marcar(imgs[i]);
  }

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') t.classList.add('is-cargada');
  }, true);

  document.addEventListener('error', function (e) {
    var t = e.target;
    /* Una foto que no llega tampoco puede quedarse latiendo: se apaga el brillo
       y se deja el gris, que al menos se lee como "aquí había una imagen". */
    if (t && t.tagName === 'IMG') t.classList.add('es-fallida');
  }, true);

  barrer(document);

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodos = muts[i].addedNodes;
        for (var j = 0; j < nodos.length; j++) {
          var n = nodos[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG') marcar(n);
          else if (n.querySelectorAll) barrer(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Red de seguridad: si algo se cuela entre el barrido y el observador, un
     último repaso al terminar de cargar la página. */
  window.addEventListener('load', function () { barrer(document); });
})();
